import { FunctionComponent, ReactNode } from 'react';

export type MessageValues = Record<
  string,
  | ReactNode
  | React.ReactElement
  | FunctionComponent<React.PropsWithChildren<unknown>>
>;

export type MessageType = {
  id: string;
  defaultMessage: string;
  values?: MessageValues;
};

export function isMessageType(message: any): message is MessageType {
  if (!message) {
    return false;
  }

  return message?.id !== undefined && message.defaultMessage !== undefined;
}
